import Image from 'next/image';

import React, { useEffect, useState } from 'react';

import TabsDiferenciais from '../../../components/Tabs/TabsDiferenciais';
import { customLoader } from '../../../utils/customLoaderImage';
import { imagemSizes } from '../../../utils/ImageFindSizes';

import style from './diferenciais.module.scss';

const parse = require('html-react-parser');

export default function Diferenciais({ data }) {
  const [listInfo, setListInfo] = useState([]);

  useEffect(() => {
    if (data?.informacoesIcones && data?.informacoesItens) {
      const infoList = data.informacoesItens.map((item, index) => ({
        icon: (
          <div key={`item: ${item}`}>
            <Image
              src={data.informacoesIcones[index]}
              width={40}
              height={40}
              layout='fixed'
              objectFit='fill'
              alt='Ícone de diferencial'
              quality={100}
              priority
            />
          </div>
        ),
        text: item,
      }));

      setListInfo(infoList);
    }
  }, [data]);

  if (!data) return null;

  const { informacoesImagem } = data;

  return (
    <div className={style.section}>
      <div className={style.image}>
        <figure>
          {informacoesImagem?.url && (
            <Image
              src={imagemSizes({ imagem: informacoesImagem }) || '/img/loading-wall.gif'}
              loader={customLoader}
              width={920}
              height={1080}
              layout='responsive'
              objectFit='cover'
              alt={informacoesImagem?.titulo}
              sizes='(max-width: 768px) 90vw, (max-width: 1200px) 50vw, 33vw'
              quality={100}
              priority
            />
          )}
          <figcaption>{informacoesImagem?.titulo}</figcaption>
        </figure>
      </div>

      <TabsDiferenciais
        contentTab1={(
          <div className={style.contentTab}>
            <ul>
              {listInfo
                && listInfo.map(
                  (info) => info.text && (
                  <li
                    key={info.text}
                    className={style.info}>
                    <div className={style.icon}>
                      <div />
                      <div />
                    </div>
                    {info.icon}
                    <h3>{parse(info.text)}</h3>
                  </li>
                  ),
                )}
            </ul>
          </div>
        )}
      />
    </div>
  );
}
